export const transactionManagement = {
  transactionManagement: {
    tabs: {
      player: "Search With Player Name/ID",
      round: "Search With Round ID",
    },
    columns: {
      username: "Username",
      tableStatus: "Table Status",
      playerCards: "Player Cards",
      otherPlayerCards: "Other Players",
      communityCards: "Community Cards",
      type: "Action Type",
      amount: "Amount",
      phaseTitle: "Game Phase",
      timestamp: "Timestamp",
      isBetHappened: "Bet Status",
      betsOpen: "Bet Open",
      betsClosed: "Bet Closed",
      winner: "Winner",
      noWinnerYet: "No winner yet",
      noCards: "No Cards",
      detail: "Game Details",
      userAction: {
        PLAYER_FOLD: "FOLD",
        PLAYER_CALL: "CALL",
        PLAYER_SIT: "SIT",
        PLAYER_CHECK: "CHECK",
        PLAYER_BET: "BET",
        PLAYER_RAISE: "RAISE",
        PLAYER_ALLIN: "ALLIN",
        BIG_BLINDS_POSTED: "BIG BLINDS POSTED",
        SMALL_BLINDS_POSTED: "SMALL BLINDS POSTED",
        PLAYER_LEAVE: "LEAVE",
      },
      phase: {
        TURN: "TURN",
        RIVER: "RIVER",
        FLOP: "FLOP",
        PRE_FLOP: "PREFLOP",
        INIT: "INIT",
        SHOWDOWN: "SHOWDOWN",
        DEAL: "DEAL",
      },
    },
    filters: {
      lobbyId: "Lobby",
      lobbyId_placeholder: "Enter Lobby",
      lobbyId_required: "Please enter Lobby",
      gameType: "Game Type",
      gameType_placeholder: "Enter Game Type",
      gameType_required: "Please enter Game Type",
      tableName: "Table Name",
      tableName_placeholder: "Enter Table Name",
      tableName_required: "Please enter Table Name",
      username: "Player Name",
      username_placeholder: "Search Player Name",
      username_required: "Please enter Player Name",
      dateRange: "Start Time- End Time",
      dateRange_placeholder: "Enter Start Time- End Time",
      dateRange_required: "Please enter Start Time- End Time",
      gameId: "Round ID",
      gameId_placeholder: "Enter Round ID",
      gameId_required: "Please enter Round ID",
      tableName_disabled: "Please select a Lobby and Game Type first",
    },
    details: {
      name: "Game Name",
      generalGameInfoHeader: "General Game Information",
      gameStateHeader: "Game State",
      playerInfoHeader: "Player Information",
      lobbyId: "Lobby ID",
      tableId: "Table ID",
      roundId: "Round ID",
      gameId: "Game ID",
      type: "Type",
      limitType: "Limit Type",
      totalSeats: "Total Seats",
      occupiedSeats: "Occupied Seats",
      minPlayers: "Minimum Players",
      maxBuyIn: "Maximum Buy-In",
      minBuyIn: "Minimum Buy-In",
      phase: "Phase",
      pot: "Pot",
      blinds: "Blinds",
      lastAction: "Last Action",
      lastActionAmount: "Last Action Amount",
      currentPlayer: "Current Player",
      timeoutDefaultAction: "Timeout Default Action",
      serviceFeePercent: "Service Fee (%)",
      tipPot: "Tip Pot",
      communityCards: "Community Cards",
      chips: "Chips",
      balance: "Balance",
      seatIndex: "Seat Index",
      betAmount: "Bet Amount",
      cards: "Cards",
      noCards: "No Cards",
      winner: "Winner",
      ante: "Ante",
      inProgress: "Game In Progress",
      inProgressTrue: "Yes",
      inProgressFalse: "No",
      isActive: "Table Active",
      isActiveTrue: "Active",
      isActiveFalse: "Inactive",
      isBetHappened: "Bet Happened",
      isBetHappenedTrue: "Yes",
      isBetHappenedFalse: "No",
      isPasswordProtected: "Password Protected",
      isPasswordProtectedTrue: "Yes",
      isPasswordProtectedFalse: "No",
      lastRaiseAmount: "Last Raise Amount",
    },
    detailDrawer: {
      roundTransactions: {
        title: "Round Transactions",
        tableInfo: "Table Information",
        name: "Table Name",
        type: "Table Type",
        currency: "Currency",
        blinds: "Big Blind - Small Blind",
        bbsb: "BB - SB",
        totalSeats: "Total Seats",
        buyInRange: "Buy-In Range",
        lobbyId: "Lobby ID",
        roundId: "Round ID",
        roundInfo: "Round Information",
        createdAt: "Round Starting Date",
        BB: "BB",
        SB: "SB",
        dealer: "Dealer",
        roundStatus: "Round Status",
        roundPot: "Round Pot",
        roundWinner: "Round Winner",
        playerSeats: "Round Player Seats",
        roundTransactions: "Round Transactions",
        username: "Username",
        type: "Type",
        amount: "Amount",
        combination: "Combination",
        activityDate: "Activity Date",
      },
    },
  },
};
